module.exports = __webpack_public_path__ + "img/world_of_acredo@2x.e4b07d4.png";